export const TRANSITIONS_DURATIONS = {
    folding: 250,
    afterFolding: 300,
    observingSlides: 500,
    observingThumbs: 250,
    scrollIntoView: 100,
    scrollIntoViewOverall: 1000,
    scrollToRoot: 1000,
};
